import React, {FC} from "react";
import {observer} from "mobx-react";

import {Section} from "controls/react/layout/section";
import {FormEntryNew} from "controls/react/form/formEntryNew";
import {i18n} from "core/localization";
import {SketchColorPickerPlain} from "controls/react/colorPicker/sketchColorPicker";
import {getLabelPositionOptions, getLabelVisibilityOptions, LabelOptions, LabelPosition} from "./types";
import {AntSelect} from "controls/react/ant/antSelect";
import {AntInputNumber} from "controls/react/ant/antInputNumber";

type LabelOptionsProps = {
	model: LabelOptions
	name: string
	positions?: LabelPosition[]
}

export const LabelOptionsEditor: FC<LabelOptionsProps> = observer(({model, name, positions}) => {
	React.useEffect(() => {
		if(model.size == null){
			model.size = 20;
		}
	}, [model.size]);

	const positionsOptions = React.useMemo(() => {
		if(positions == null)
			return [];

		return getLabelPositionOptions()
			.filter(x => positions.indexOf(x.value as LabelPosition) != -1);
	}, [positions?.join()]);

	return <Section appearance={"none"} childrenPadding={true} direction={"row"}>
		<FormEntryNew label={name} width={150} model={model} modelField={"visibility"}>
			<AntSelect options={getLabelVisibilityOptions()}/>
		</FormEntryNew>
		<FormEntryNew label={i18n('Color')} model={model} modelField={"color"}>
			<SketchColorPickerPlain/>
		</FormEntryNew>
		<FormEntryNew  label={i18n('Font size')} width={100} model={model} modelField={"size"}>
			<AntInputNumber/>
		</FormEntryNew>
		{positionsOptions.length > 0 &&
			<FormEntryNew label={i18n('Position')} width={150} model={model} modelField={"position"}>
				<AntSelect options={positionsOptions}/>
			</FormEntryNew>
		}
		{/*<FormEntryNew label={i18n('ALlignement')} model={model} modelField={"fontColor"}>*/}
		{/*	<SketchColorPickerPlain/>*/}
		{/*</FormEntryNew>*/}
	</Section>
})
